import { render, staticRenderFns } from "./PaymentCancel.vue?vue&type=template&id=13381f38&"
import script from "./PaymentCancel.vue?vue&type=script&lang=js&"
export * from "./PaymentCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports